import { formatDate } from '@fukuri-admins/utils/common/date';
import { useGetClientUser } from '~/hooks';
import { ROUTES, replaceRouteParams } from '~/utils/routes';
import { UserDetailProfilePresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof UserDetailProfilePresentation>;

type Args = {
  data: ReturnType<typeof useGetClientUser>['data'];
  userId: number;
};

type IConvertToPresentationProps = (
  args: Args
) => Pick<
  PresentationProps,
  | 'fullName'
  | 'email'
  | 'branchName'
  | 'branchCode'
  | 'billableFromLabel'
  | 'createdAtLabel'
  | 'updatedAtLabel'
  | 'editLink'
>;

export const convertToPresentationProps: IConvertToPresentationProps = ({ data, userId }) => {
  const { user } = data;
  return {
    fullName: user.full_name,
    email: user.email,
    branchName: user.branch?.name,
    branchCode: user.branch?.code,
    billableFromLabel: user.billable_from
      ? formatDate({ date: new Date(`${user.billable_from}T00:00:00`), formatType: 'yyyy/M/d' })
      : '-',
    createdAtLabel: formatDate({
      date: new Date(user.created_at * 1000),
      formatType: 'yyyy/M/d H:mm',
    }),
    updatedAtLabel: formatDate({
      date: new Date(user.updated_at * 1000),
      formatType: 'yyyy/M/d H:mm',
    }),
    editLink: replaceRouteParams(ROUTES.USER_EDIT, { id: userId }),
  };
};
